import { render } from "./TruncatedText.vue?vue&type=template&id=43ab6746"
import script from "./TruncatedText.vue?vue&type=script&lang=js"
export * from "./TruncatedText.vue?vue&type=script&lang=js"

import "./TruncatedText.vue?vue&type=style&index=0&id=43ab6746&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__